import React from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import './custom-toaster.css';

const CustomToast = ({ show, onClose, message, type = '' }) => {
  const getToastClass = () => {
    switch (type) {
      case 'success':
        return 'toast-success';
      case 'error':
        return 'toast-error';
      case 'info':
        return 'toast-info';
      case 'warning':
        return 'toast-warning';
      default:
        return 'toast-success';
    }
  };

  return (
    <ToastContainer position="top-end" className="p-3">
      <Toast
        className={`custom-toast ${getToastClass()}`}
        onClose={onClose}
        show={show}
        delay={5000}
        autohide
      >
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default CustomToast;